import { render, staticRenderFns } from "./PuntoFormulario.vue?vue&type=template&id=0bbcd04a&scoped=true"
import script from "./PuntoFormulario.vue?vue&type=script&lang=js"
export * from "./PuntoFormulario.vue?vue&type=script&lang=js"
import style0 from "./PuntoFormulario.vue?vue&type=style&index=0&id=0bbcd04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbcd04a",
  null
  
)

export default component.exports